import { render, staticRenderFns } from "./CollapseMultiSelect.vue?vue&type=template&id=120e8235&scoped=true&"
import script from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseMultiSelect.vue?vue&type=style&index=0&id=120e8235&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e8235",
  null
  
)

export default component.exports